import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import {
  GOAL_OPERATOR_TYPES_STRING_VALUES,
  getDestUrlData,
  getEventData,
  CONTEXTUAL_ENTITY_TYPE,
} from '@bingads-webui-campaign/recommendation-core';
import { withContextualAttributeTemplate } from '@bingads-webui-campaign/recommendation-contextual-attribute';

import destUrlemplate from './suggested-setting-column-dest-url.pug';
import eventTemplate from './suggested-setting-column-event.pug';
import UETTemplate from './setting-column-UET.pug';
import revenueValueTemplate from './setting-column-revenue-value.pug';

export class SuggestedSettingColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, newI18n }) {
    super({
      name: 'SuggestedSetting',
      property: 'SuggestedSetting',
      title: i18n.getString('Details_View_Suggested_Setting'),
      bodyClasses: ['grid-column-goal-setting', 'actionable'],
      colClasses: ['col-longText'],
      type: 'string',
    });
    this.i18n = i18n;
    this.newI18n = newI18n;
  }

  contextualAttributeWrapper = options => withContextualAttributeTemplate({
    opportunityId: options.opportunityId,
    entityName: options.entityName,
    entityId: options.entityId,
    entityType: CONTEXTUAL_ENTITY_TYPE.SUGGESTED_SETTING,
    status: 'false',
    ariaLabel: this.i18n.getString('Click to scope to suggested setting'),
  })

  template({
    value: {
      Opportunities,
    },
  }) {
    const { i18n, newI18n } = this;
    const entity = Opportunities[0];
    const goalTypeId = entity.GoalTypeId;
    const goalOperatorTypes = GOAL_OPERATOR_TYPES_STRING_VALUES;
    const opportunity = _.first(Opportunities);
    const issueTypeId = entity.IssueType;

    if (goalTypeId === 0 && entity.DestUrl) { // Goal type is Destination URL
      const destUrlCurrentSetting = entity.DestUrl.CurrentSetting;
      const destUrlSuggestedSetting = entity.DestUrl.SuggestedSetting;
      const destUrlData = getDestUrlData(
        destUrlCurrentSetting,
        destUrlSuggestedSetting,
        goalOperatorTypes,
        i18n
      );

      if (destUrlData.suggestedDestinationUrl !== null &&
        destUrlData.suggestedDestinationURLOperatorName
        !== destUrlData.currentDestinationURLOperatorName) {
        destUrlData.suggestedDestinationURLOperatorName = this.contextualAttributeWrapper({
          opportunityId: opportunity.OpportunityId,
          entityName: destUrlData.suggestedDestinationURLOperatorName,
          entityId: `${opportunity.OpportunityId}_suggestedDestinationURLOperatorName`,
        });
      }

      if (destUrlData.suggestedDestinationUrl !== null &&
        destUrlData.suggestedDestinationUrl !== destUrlData.currentDestinationUrl) {
        destUrlData.suggestedDestinationUrl = this.contextualAttributeWrapper({
          opportunityId: opportunity.OpportunityId,
          entityName: destUrlData.suggestedDestinationUrl,
          entityId: `${opportunity.OpportunityId}_suggestedDestinationUrl`,
        });
      }
      return destUrlemplate(destUrlData);
    } else if (goalTypeId === 3 && entity.Event) { // Goal type is Event
      const eventCurrentSetting = entity.Event.CurrentSetting;
      const eventSuggestedSetting = entity.Event.SuggestedSetting;
      const eventData = getEventData(
        eventCurrentSetting,
        eventSuggestedSetting,
        goalOperatorTypes,
        i18n
      );

      if (eventData.suggestedCategoryName !== null &&
        eventData.suggestedCategoryName !== eventData.currentCategoryName) {
        eventData.suggestedCategoryName = this.contextualAttributeWrapper({
          opportunityId: opportunity.OpportunityId,
          entityName: eventData.suggestedCategoryName,
          entityId: `${opportunity.OpportunityId}_suggestedCategoryName`,
        });
      }

      if (eventData.suggestedCategoryName !== null &&
        eventData.suggestedCategoryOperatorName !== eventData.currentCategoryOperatorName) {
        eventData.suggestedCategoryOperatorName = this.contextualAttributeWrapper({
          opportunityId: opportunity.OpportunityId,
          entityName: eventData.suggestedCategoryOperatorName,
          entityId: `${opportunity.OpportunityId}_suggestedCategoryOperatorName`,
        });
      }

      if (eventData.suggestedActionName !== null &&
        eventData.suggestedActionName !== eventData.currentActionName) {
        eventData.suggestedActionName = this.contextualAttributeWrapper({
          opportunityId: opportunity.OpportunityId,
          entityName: eventData.suggestedActionName,
          entityId: `${opportunity.OpportunityId}_suggestedActionName`,
        });
      }

      if (eventData.suggestedActionName !== null &&
        eventData.suggesteActionOperatorName !== eventData.currentActionOperatorName) {
        eventData.suggesteActionOperatorName = this.contextualAttributeWrapper({
          opportunityId: opportunity.OpportunityId,
          entityName: eventData.suggesteActionOperatorName,
          entityId: `${opportunity.OpportunityId}_suggesteActionOperatorName`,
        });
      }

      if (eventData.suggestedLabelName !== null &&
        eventData.suggestedLabelName !== eventData.currentLabelName) {
        eventData.suggestedLabelName = this.contextualAttributeWrapper({
          opportunityId: opportunity.OpportunityId,
          entityName: eventData.suggestedLabelName,
          entityId: `${opportunity.OpportunityId}_suggestedLabelName`,
        });
      }

      if (eventData.suggestedLabelName !== null &&
        eventData.suggestedLabelOperatorName !== eventData.currentLabelOperatorName) {
        eventData.suggestedLabelOperatorName = this.contextualAttributeWrapper({
          opportunityId: opportunity.OpportunityId,
          entityName: eventData.suggestedLabelOperatorName,
          entityId: `${opportunity.OpportunityId}_suggestedLabelOperatorName`,
        });
      }

      if (eventData.suggestedValueName !== null &&
        eventData.suggestedValueName !== eventData.currentValueName) {
        eventData.suggestedValueName = this.contextualAttributeWrapper({
          opportunityId: opportunity.OpportunityId,
          entityName: eventData.suggestedValueName,
          entityId: `${opportunity.OpportunityId}_suggestedValueName`,
        });
      }

      if (eventData.suggestedValueName !== null &&
        eventData.suggesteValueOperatorName !== eventData.currentValueOperatorName) {
        eventData.suggesteValueOperatorName = this.contextualAttributeWrapper({
          opportunityId: opportunity.OpportunityId,
          entityName: eventData.suggesteValueOperatorName,
          entityId: `${opportunity.OpportunityId}_suggesteValueOperatorName`,
        });
      }
      return eventTemplate(eventData);
    } else if (issueTypeId === 3 && entity.ImpactScope) {
      return newI18n.getString(_TL_('Across all accounts'));
    } else if (issueTypeId === 5 && entity.UET) {
      const UETData = {
        suggestedEvent: entity.UET.SuggestedEvent,
        suggestedEventLabel: newI18n.getString(_TL_('Suggested Associated UET')),
      };
      return UETTemplate(UETData);
    } else if (issueTypeId === 4 && entity.RevenueValue) {
      const revenueValueData = {
        goalValueSourceId: entity.RevenueValue.GoalValueSourceId,
        sameGoalOrNotAssignGoaText: newI18n.getString(_TL_('Conversion action value may vary (Default value: 1)')),
        variousGoalText: newI18n.getString(_TL_('Click Edit to get action detail')),
      };
      return revenueValueTemplate(revenueValueData);
    }
    return '<div/>'; // This is unexpected result. Output empty result.
  }

  get property() {
    return {
      get: _.identity,
      property: 'SuggestedSetting',
    };
  }
}
